import { render } from "./UserPhysiologicalData.vue?vue&type=template&id=35b003ad&scoped=true"
import script from "./UserPhysiologicalData.vue?vue&type=script&lang=js"
export * from "./UserPhysiologicalData.vue?vue&type=script&lang=js"

import "./UserPhysiologicalData.vue?vue&type=style&index=0&id=35b003ad&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b003ad"]])

export default __exports__